import type { Bcp47Locale } from '@backmarket/http-api'

const UNITS = ['year', 'month', 'day', 'hour', 'minute', 'second'] as const

export type Unit = (typeof UNITS)[number]
export type RelativeTimeFormatValues = Record<Unit, number>

export default function createNumberFormatter(
  locale: Bcp47Locale,
  options: Intl.RelativeTimeFormatOptions = {},
) {
  return (values: RelativeTimeFormatValues) =>
    UNITS.map((unit) => {
      const value = values[unit]

      if (value) {
        const formatter = new Intl.RelativeTimeFormat(locale, options)

        const parts = formatter.formatToParts(value, unit)

        return `${parts[1]?.value ?? ''}${parts[2]?.value ?? ''}`
      }

      return ''
    }).join(' ')
}
